import { render, staticRenderFns } from "./TwoImages.vue?vue&type=template&id=4cba4718&scoped=true&"
import script from "./TwoImages.vue?vue&type=script&lang=js&"
export * from "./TwoImages.vue?vue&type=script&lang=js&"
import style0 from "./TwoImages.vue?vue&type=style&index=0&id=4cba4718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba4718",
  null
  
)

export default component.exports